import"inter-ui/inter.css";import{css as _n}from"styled-components";var tt={xs:425,sm:640,md:768,lg:1024,xl:1280};var ne={gray:{gray1:"#17181C",gray2:"#1A1B1F",gray3:"#1E1F24",gray4:"#202127",gray5:"#23242A",gray6:"#25272D",gray7:"#27292F",gray8:"#2E3038",gray9:"#3C3F48",gray10:"#4A4D59",gray11:"#9A9DAD",gray12:"#EDEEF0"},blue:{blue1:"#131620",blue2:"#151A2D",blue3:"#192140",blue4:"#1C264F",blue5:"#1F2B5C",blue6:"#22316E",blue7:"#273B89",blue8:"#2F49B2",blue9:"#3E5EDD",blue10:"#5371E7",blue11:"#849DFF",blue12:"#EEF1FD"},red:{red1:"#1F1315",red2:"#291415",red3:"#3C181A",red4:"#481A1D",red5:"#541B1F",red6:"#822025",red7:"#AA2429",red8:"#AA2429",red9:"#E5484D",red10:"#F2555A",red11:"#FF6369",red12:"#FEECEE"},green:{green1:"#0D1912",green2:"#0C1F17",green3:"#0F291E",green4:"#113123",green5:"#133929",green6:"#164430",green7:"#1B543A",green8:"#236E4A",green9:"#30A46C",green10:"#3CB179",green11:"#4CC38A",green12:"#E5FBEB"},yellow:{yellow1:"#1F1300",yellow2:"#271700",yellow3:"#341C00",yellow4:"#3F2200",yellow5:"#4A2900",yellow6:"#573300",yellow7:"#693F05",yellow8:"#824E00",yellow9:"#FFB224",yellow10:"#FFCB47",yellow11:"#F1A10D",yellow12:"#FEF3DD"},violet:{violet1:"#17151F",violet2:"#1C172B",violet3:"#251E40",violet4:"#2C2250",violet5:"#32275F",violet6:"#392C72",violet7:"#392C72",violet8:"#5842C3",violet9:"#6E56CF",violet10:"#7C66DC",violet11:"#9E8CFC",violet12:"#F1EEFE"}},rt={...ne.gray,...ne.blue,...ne.red,...ne.green,...ne.yellow,...ne.violet,black:"#000000",white:"#FFFFFF"},nt={gray50:"#FAFAFA",gray100:"#F4F4F5",gray200:"#E3E4E8",gray300:"#C2C4CC",gray400:"#9DA1AE",gray500:"#6B6F80",gray600:"#4F525E",gray700:"#2F3138",gray800:"#26282E",gray850:"#1E1F24",gray900:"#17181C",red400:"#F87171",red500:"#EF4444",green400:"#34D399",green500:"#10B981",blue400:"#5F8FF5",blue500:"#477FF7",blue600:"#3170F7",purple400:"#C084FC",purple500:"#A855F7",yellow400:"#FBBF24",yellow500:"#F59E0B",black:"#000000",white:"#FFFFFF"};var it={xxxs:10,xxs:12,xs:13,sm:14,base:16,lg:18,xl:24};var at={sm:"0px 1px 2px rgba(0, 0, 0, 0.05)",base:"0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px -1px rgba(0, 0, 0, 0.1)",md:"0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -2px rgba(0, 0, 0, 0.1)",lg:"0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -4px rgba(0, 0, 0, 0.1)"};var st={s0:"0rem",s1:"0.25rem",s2:"0.5rem",s3:"0.75rem",s4:"1rem",s5:"1.25rem",s6:"1.5rem"};var pt='"Inter var", "system-ui"',lt='"Fira Code", monospace';var pn={fontStyle:"normal",WebkitFontSmoothing:"antialiased",MozOsxFontSmoothing:"grayscale"},O={...pn,fontFamily:pt,fontWeight:400},Pe={...O,fontFamily:lt},ae={...O,fontWeight:500},N={...O,fontWeight:600},ln={...O,fontSize:"12px",lineHeight:"18px"},cn={...O,fontSize:"13px",lineHeight:"18px"},dn={...O,fontWeight:450,fontSize:"13px",lineHeight:"18px"},mn={...O,fontSize:"14px",lineHeight:"20px"},gn={...O,fontWeight:450,fontSize:"14px",lineHeight:"20px"},fn={...O,fontSize:"16px",lineHeight:"24px"},un={...O,fontWeight:450,fontSize:"16px",lineHeight:"24px"},yn={...O,fontSize:"18px",lineHeight:"26px"},xn={...O,fontWeight:450,fontSize:"18px",lineHeight:"26px"},bn={...O,fontSize:"20px",lineHeight:"30px"},hn={...ae,fontSize:"13px",lineHeight:"19.5px"},Tn={...ae,fontSize:"14px",lineHeight:"20px"},In={...ae,fontSize:"16px",lineHeight:"24px"},Pn={...ae,fontSize:"18px",lineHeight:"26px"},Cn={...ae,fontSize:"20px",lineHeight:"28px"},Sn={...ae,fontSize:"26px",lineHeight:"30px"},$n={...Pe,fontSize:"11px",lineHeight:"15.4px"},wn={...Pe,fontSize:"12px",lineHeight:"16.8px"},vn={...Pe,fontSize:"13px",lineHeight:"20px"},Rn={...Pe,fontSize:"14px",lineHeight:"19.6px"},kn={...Pe,fontSize:"16px",lineHeight:"22.4px"},Mn={...N,fontSize:"16px",lineHeight:"20px"},Dn={...N,fontSize:"18px",lineHeight:"22.5px",letterSpacing:"-0.01em"},Bn={...N,fontSize:"20px",lineHeight:"25px",letterSpacing:"-0.01em"},Fn={...N,fontSize:"24px",lineHeight:"30px",letterSpacing:"-0.01em"},zn={...N,fontSize:"32px",lineHeight:"36.8px",letterSpacing:"-0.02em"},En={...N,fontSize:"40px",lineHeight:"46px",letterSpacing:"-0.02em"},On={...N,fontSize:"48px",lineHeight:"55.2px",letterSpacing:"-0.02em"},Ln={...N,fontSize:"56px",lineHeight:"61.6px",letterSpacing:"-0.02em"},An={...N,fontSize:"64px",lineHeight:"70.4px",letterSpacing:"-0.02em"},Nn={...N,fontSize:"14px",lineHeight:"21px",letterSpacing:"-0.02em"},Vn={...N,fontSize:"16px",lineHeight:"24px",letterSpacing:"-0.02em"},Hn={text2Xs:ln,textXs:cn,textXsPlus:dn,textSm:mn,textSmPlus:gn,textBase:fn,textBasePlus:un,textLg:yn,textLgPlus:xn,textXl:bn},Wn={headingXs:hn,headingSm:Tn,headingBase:In,headingLg:Pn,headingXl:Cn,headingBIGXL:Sn},Gn={titleBase:Mn,titleLg:Dn,titleXl:Bn,title2Xl:Fn,title3Xl:zn,title4Xl:En,title5Xl:On,title6Xl:Ln,title7Xl:An,titleCapsSm:Nn,titleCapsBase:Vn},Xn={mono3Xs:$n,mono2Xs:wn,monoXs:vn,monoSm:Rn,monoBase:kn},ie={fontFamily:{primary:pt,secondary:lt},fontWeight:{normal:400,bold:500,title:600},styleSet:{text:Hn,heading:Wn,title:Gn,mono:Xn}},xo={...ie.styleSet.text,...ie.styleSet.heading,...ie.styleSet.title,...ie.styleSet.mono};var q={colors:{...rt,...nt},typography:ie,styleSet:Object.keys(xo).reduce((e,o)=>({...e,[o]:_n(xo[o])}),{}),spacing:st,shadows:at,breakpoints:tt,iconSizes:it};import{ThemeProvider as Un,createGlobalStyle as jn,useTheme as Zn}from"styled-components";import{jsx as Jn,jsxs as qn}from"react/jsx-runtime";var Kn=({children:e,theme:o=q,...t})=>qn(Un,{...t,theme:o,children:[Jn(Yn,{}),e]}),Ce=Zn;var Yn=jn`
  *, *:after, *:before {
    box-sizing: border-box;
  }

  /* TODO: should use @radix-ui/react-scroll-area */
  ::-webkit-scrollbar {
    display: none;
  }
`;import{forwardRef as Qn}from"react";import ei,{css as oi}from"styled-components";import{jsx as ri}from"react/jsx-runtime";var g=Qn(({variant:e="textBase",color:o="inherit",tag:t,...r},n)=>ri(ti,{ref:n,...r,$color:o,$variant:e,as:t}));var ti=ei.span`
  ${({theme:e,$variant:o="textBase",$color:t="inherit"})=>{let r=e.colors[t]??t;return oi`
      ${e.styleSet[o]};
      color: ${r};
      text-decoration-color: ${r};
      text-decoration: none;
      margin: unset;
      width: fit-content;
      cursor: inherit;
    `}};
`;import{forwardRef as ni}from"react";import mt,{css as bo}from"styled-components";import{FontAwesomeIcon as ii}from"@fortawesome/react-fontawesome";import{jsx as Oe}from"react/jsx-runtime";var x=ni(({className:e,icon:o,size:t="xs",color:r="inherit",spin:n,...a},i)=>{let s=Ce();if(typeof o=="string"){let p=/^(fas|far|fal|fat|fad|fab|fak)-(.+)$/.exec(o);if(p){let[c,d,y]=p;return Oe(ct,{$size:t,className:e,ref:i,children:Oe(dt,{...a,$spin:n,color:s.colors[r]??r,icon:[d,y]})})}return null}return Oe(ct,{$size:t,className:e,ref:i,children:Oe(dt,{...a,$spin:n,color:s.colors[r]??r,icon:o})})});var ct=mt.div`
  ${({theme:e,$size:o="xs"})=>{let t=`${typeof o=="number"?o:e.iconSizes[o]}px`;return bo`
      display: flex;
      justify-content: center;
      align-items: center;
      aspect-ratio: 1/1;
      flex-shrink: 0;
      white-space: nowrap;
      height: ${t};
      width: ${t};
    `}}
`,dt=mt(ii)`
  ${({$spin:e})=>bo`
    width: 100%;
    height: 100%;

    ${e?bo`
          animation: spin infinite 1s linear;

          @keyframes spin {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }
        `:void 0}
  `}
`;import{forwardRef as ai}from"react";import{Slot as si}from"@radix-ui/react-slot";import pi,{css as li}from"styled-components";import{jsx as gt}from"react/jsx-runtime";var Bd=ai(({children:e,asChild:o,variant:t="textSm",color:r="blue11",newWindow:n,...a},i)=>gt(ci,{$color:r,$variant:t,...a,target:n?"_blank":a.target,onClick:a.onClick,ref:i,children:o?e:gt("a",{children:e})}));var ci=pi(si)`
  ${({theme:e,$color:o="blue11",$variant:t="textSm"})=>{let r=e.colors[o]??o;return li`
      ${e.styleSet[t]};

      color: ${r};
      text-decoration-color: ${r};

      text-decoration: none;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    `}}
`;import{forwardRef as di}from"react";import ut,{css as ft}from"styled-components";import{jsx as ho}from"react/jsx-runtime";var Ad=di(({name:e,imageSrc:o,size:t,bgColor:r,...n},a)=>ho(mi,{ref:a,...n,$bgColor:r,$size:t,children:o?ho(gi,{alt:"avatar",src:o}):e?ho(g,{color:"gray12",tag:"label",variant:"textSmPlus",children:e.trim().charAt(0).toUpperCase()}):null}));var mi=ut.div`
  ${({theme:e,$size:o=28,$bgColor:t="gray9",onClick:r})=>ft`
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0px;
      width: ${o}px;
      height: ${o}px;
      border-radius: 50%;
      background-color: ${e.colors[t]??t};
      user-select: none;
      overflow: hidden;
      white-space: normal;
      flex-shrink: 0;

      ${r&&ft`
        cursor: pointer;
        &:hover {
          background-color: ${e.colors.gray10};
        }
      `}
    `}
`,gi=ut.img`
  aspect-ratio: 1/1;
  width: 100%;
  height: 100%;
`;import{forwardRef as fi}from"react";import ui,{css as yi}from"styled-components";import yt from"chroma-js";var v=(e="",o=1)=>yt.valid(e)?yt(e).alpha(o).css():"inherit";import{jsx as xt}from"react/jsx-runtime";var jd=fi(({children:e,color:o="gray11",textVariant:t="textSm",...r},n)=>xt(xi,{...r,$color:o,ref:n,children:xt(g,{color:o,tag:"label",variant:t,children:e})}));var xi=ui.div`
  ${({theme:e,$color:o})=>yi`
    display: flex;
    flex-direction: row;
    flex: 0;
    align-items: flex-start;
    padding: 0px 6px;
    gap: 4px;
    width: fit-content;
    white-space: nowrap;
    border-radius: 4px;
    background-color: ${v(e.colors[o],.08)};
  `}
`;import{forwardRef as bi}from"react";import To,{css as Ae}from"styled-components";import{jsx as Le,jsxs as Ci}from"react/jsx-runtime";var hi=bi(({icon:e,imgSrc:o,svg:t,spin:r,innerSize:n="xs",...a},i)=>{if(e||o||t)return Le(hi,{...a,ref:i,children:e?Le(x,{color:a.color,icon:e,size:n,spin:r}):Le(Pi,{$size:n,$spin:r,alt:"svg-boxed-icon",src:o??t})});let{children:s,dimension:l="36px",statusColor:p,color:c,...d}=a;return Ci(Ti,{$color:c,$dimension:l,...d,ref:i,children:[s,p?Le(Ii,{$color:p}):null]})});var Ti=To.div`
  ${({theme:e,$dimension:o,$color:t="gray11"})=>Ae`
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0px;
    isolation: isolate;
    box-sizing: border-box;
    flex-shrink: 0;
    white-space: nowrap;
    border-radius: 8px;
    overflow: hidden;

    width: ${o};
    height: ${o};

    color: ${e.colors[t]??t};
    background-color: ${e.colors.gray3};
    box-shadow: inset 0 0 0 1px ${e.colors.gray7};

    &:hover {
      background-color: ${e.colors.gray4};
      box-shadow: inset 0 0 0 1px ${e.colors.gray8};
    }
  `}
`,Ii=To.div`
  ${({theme:e,$color:o="gray11"})=>Ae`
      position: absolute;
      width: 8px;
      height: 8px;
      left: 19px;
      top: 19px;
      border-radius: 50%;
      box-shadow: inset 0 0 0 1px ${e.colors.gray1};
      background-color: ${e.colors[o]};
    `}
`,Pi=To.img`
  ${({theme:e,$size:o="xs",$spin:t})=>{let r=`${typeof o=="number"?o:e.iconSizes[o]}px`;return Ae`
      height: ${r};
      width: ${r};
      max-height: ${r};
      max-width: ${r};

      ${t?Ae`
            animation: spin infinite 1s linear;

            @keyframes spin {
              from {
                transform: rotate(0deg);
              }
              to {
                transform: rotate(360deg);
              }
            }
          `:void 0}
    `}}
`;import Li from"styled-components";import{forwardRef as Si}from"react";import $i,{css as S}from"styled-components";import{jsx as Mi,jsxs as Di}from"react/jsx-runtime";var wi={secondary:"gray",primary:"blue",danger:"red",success:"green",info:"violet"},vi=Si(({children:e,buttonTheme:o="primary",variant:t="solid",size:r="sm",text:n,icon:a,width:i,height:s,...l},p)=>Di(ki,{...l,$height:s,$size:r,$themeColor:wi[o],$variant:t,ref:p,style:{width:i,height:s,...l.style},children:[a?Mi(x,{icon:a,size:"xs"}):null,n??e]})),F=vi,Ri={sm:{fontVariant:"textSmPlus",height:"36px",gap:"8px",padding:"0px 12px"},lg:{fontVariant:"headingBase",height:"48px",gap:"12px",padding:"0px 16px"}},ki=$i.button`
  ${({theme:e,$themeColor:o,$variant:t,$size:r})=>{let{fontVariant:n="textSmPlus",...a}=Ri[r],i=S`
      display: inline-flex;
      white-space: nowrap;
      flex-shrink: 0;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      min-width: fit-content;
      width: max-content;
      box-sizing: border-box;
      border-radius: 8px;
      overflow: hidden;
      cursor: pointer;

      /* SIZE */
      ${e.styleSet[n]};
      ${S(a)};
      ${t==="inline"&&S`
        height: initial;
        padding: initial;
        border-radius: initial;
      `};

      &:disabled {
        pointer-events: none;
        opacity: 0.5;
      }
    `,s=S`
      ${t==="solid"&&S`
        background-color: ${e.colors[`${o}9`]};
        &:hover,
        &:active {
          background-color: ${e.colors[`${o}10`]};
        }
      `};
      ${t==="outline"&&S`
        background-color: ${e.colors[`${o}3`]};
        &:hover {
          background-color: ${e.colors[`${o}4`]};
        }
        &:active {
          background-color: ${e.colors[`${o}5`]};
        }
      `};
      ${t==="ghost"&&S`
        &:hover {
          background-color: ${e.colors[`${o}4`]};
        }
        &:active {
          background-color: ${e.colors[`${o}5`]};
        }
      `};
      ${t==="muted"&&S`
        background-color: ${e.colors[`${o}7`]};
        &:hover,
        &:active {
          background-color: ${e.colors[`${o}8`]};
        }
      `};
    `,l=S`
      ${t==="outline"&&S`
        box-shadow: inset 0 0 0 1px ${e.colors[`${o}8`]};
        &:hover,
        &:active {
          box-shadow: inset 0 0 0 1px ${e.colors[`${o}9`]};
        }
      `};
      ${t==="ghost"&&S`
        &:hover,
        &:active {
          box-shadow: inset 0 0 0 1px ${e.colors[`${o}8`]};
        }
      `};
      ${t==="muted"&&S`
        box-shadow: inset 0 0 0 1px ${e.colors[`${o}5`]};
        &:hover,
        &:active {
          box-shadow: inset 0 0 0 1px ${e.colors[`${o}6`]};
        }
      `};
    `,p=S`
      ${t==="solid"&&S`
        color: ${e.colors[`${o}12`]};
      `};
      ${t==="outline"&&S`
        color: ${o==="gray"?e.colors[`${o}12`]:e.colors[`${o}11`]};
      `};
      ${t==="ghost"&&S`
        color: ${e.colors[`${o}11`]};
        &:hover,
        &:active {
          color: ${o==="gray"?e.colors[`${o}12`]:e.colors[`${o}11`]};
        }
      `};
      ${t==="inline"&&S`
        color: ${e.colors[`${o}11`]};
        &:hover,
        &:active {
          color: ${e.colors[`${o}12`]};
        }
      `};
      ${t==="muted"&&S`
        color: ${e.colors[`${o}12`]};
      `};
    `;return S`
      all: unset;
      ${i};
      ${s};
      ${l};
      ${p};
    `}}
`;import{forwardRef as Bi}from"react";import Fi from"styled-components";import{jsx as bt}from"react/jsx-runtime";var zi={xs:"xs",sm:"xs"},Ei=Bi(({icon:e,size:o="sm",...t},r)=>bt(Oi,{ref:r,...t,children:bt(x,{icon:e,size:zi[o]})})),z=Ei,Oi=Fi(F)`
  text-align: center;
  padding: 0;
  aspect-ratio: 1/1;
  width: unset;
`;var gm=Li.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: max-content;
`;import{forwardRef as Ai}from"react";import Ve,{css as ht}from"styled-components";import{Root as Ni,Portal as Vi,Overlay as Hi,Content as Wi,DialogTrigger as Gi}from"@radix-ui/react-dialog";import{jsx as Ne,jsxs as Ui}from"react/jsx-runtime";var Tt=Ai(({container:e,children:o,trigger:t,open:r,onOpenChange:n,maxWidth:a,minWidth:i="400px",zIndex:s,...l},p)=>Ui(Ni,{onOpenChange:n,open:r,children:[t?Ne(Gi,{asChild:!0,children:t}):void 0,Ne(Vi,{container:e,children:Ne(Xi,{$zIndex:s,children:Ne(_i,{...l,$maxWidth:a,$minWidth:i,ref:p,children:o})})})]}));var Xi=Ve(Hi)`
  ${({$zIndex:e})=>ht`
      position: fixed;
      background-color: rgba(14, 14, 17, 0.8);
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: grid;
      place-items: center;
      overflow-y: auto;
      animation: overlayShow 150ms cubic-bezier(0.16, 1, 0.3, 1);
      z-index: ${e??"auto"};

      @keyframes overlayShow {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }
    `}
`,_i=Ve(Wi)`
  ${({theme:e,$minWidth:o,$maxWidth:t})=>ht`
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      box-sizing: border-box;
      color: ${e.colors.gray12};
      background-color: ${e.colors.gray1};
      border: 1px solid ${e.colors.gray6};
      box-shadow: ${e.shadows.base};
      min-width: ${o};
      max-width: ${t};
      border-radius: 8px;
      overflow: hidden;
      outline: none;

      animation: contentShow 150ms cubic-bezier(0.16, 1, 0.3, 1);

      @keyframes contentShow {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }
    `}
`,Im=Ve.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px 24px;
  width: 100%;
`,Pm=Ve.div`
  display: flex;
  width: 100%;
  border-top: 1px solid ${e=>e.theme.colors.gray6};
  padding: ${e=>e.theme.spacing.s5};
`;import{forwardRef as ji}from"react";import Pt,{css as Zi}from"styled-components";import{faTimes as Ki}from"@fortawesome/pro-regular-svg-icons";import{jsx as It,jsxs as qi}from"react/jsx-runtime";var Mm=ji(({children:e,title:o,onClose:t,...r},n)=>qi(Yi,{ref:n,...r,$withCloseButton:!!t,children:[It(Ji,{children:e??o}),t?It(z,{buttonTheme:"secondary",icon:Ki,onClick:t,variant:"outline"}):null]}));var Yi=Pt.div`
  ${({theme:e,$withCloseButton:o})=>Zi`
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: ${o?"12px 24px":"20px 24px"};
      box-sizing: border-box;
      gap: 10px;
      border-bottom: 1px solid ${e.colors.gray6};
      width: 100%;
    `}
`,Ji=Pt(g).attrs({tag:"h3",variant:"textSmPlus",color:"gray12"})``;import{forwardRef as Qi}from"react";import ea,{css as oa}from"styled-components";import{jsx as ra}from"react/jsx-runtime";var Om=Qi(({placement:e="right",...o},t)=>ra(ta,{maxWidth:"640px",...o,$placement:e,ref:t}));var Ct={left:"translate3d(-100%,0,0)",right:"translate3d(100%,0,0)"},ta=ea(Tt)`
  && {
    ${({$placement:e="right"})=>oa`
        position: fixed;
        border-radius: 0;
        z-index: auto;
        width: 100%;
        overflow-y: scroll;

        top: 0;
        bottom: 0;
        left: ${e==="left"?0:void 0};
        right: ${e==="right"?0:void 0};

        will-change: transform;

        &[data-state="open"] {
          animation: slideIn 150ms cubic-bezier(0.22, 1, 0.36, 1);
        }

        &[data-state="close"] {
          animation: slideOut 150ms cubic-bezier(0.22, 1, 0.36, 1);
        }

        @keyframes slideIn {
          from {
            transform: ${Ct[e]};
          }
          to {
            transform: translate3d(0, 0, 0);
          }
        }

        @keyframes slideOut {
          from {
            transform: translate3d(0, 0, 0);
          }
          to {
            transform: ${Ct[e]};
          }
        }
      `}
  }
`;import*as G from"@radix-ui/react-dropdown-menu";import se,{css as Io}from"styled-components";var St=se(G.Root)``,Se=se(G.Group)`
  padding: 4px 0;
  width: 100%;
`,$t=se(G.Content)`
  ${({theme:e,$minWidth:o,$maxHeight:t})=>Io`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 4px;
    box-sizing: border-box;
    background-color: ${e.colors.gray2};
    box-shadow: ${e.shadows.sm}, inset 0 0 0 1px ${e.colors.gray6};
    border-radius: 8px;
    min-width: ${o??"auto"};
    max-height: ${t};
    overflow-y: auto;

    ${Se}:first-child {
      padding-top: 0;
    }

    ${Se}:last-child {
      padding-bottom: 0;
    }

    ${Se}:not(:last-child) {
      border-bottom: 1px solid ${e.colors.gray6};
    }
  `}
`,wt=se(G.Item)`
  ${({theme:e,$textColor:o="gray12"})=>Io`
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 8px;
      width: 100%;
      box-sizing: border-box;
      gap: 10px;
      user-select: none;
      outline: none;
      border-radius: 8px;
      ${e.styleSet.textSmPlus};
      color: ${e.colors[o]};
      cursor: pointer;

      &:hover {
        background-color: ${e.colors.gray4};
      }
    `}
`,vt=se.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`,Rt=se(G.Trigger)`
  ${e=>!e.asChild&&Io`
      all: unset;
    `}
`;import{jsx as na}from"react/jsx-runtime";var He=e=>na(St,{...e});import{forwardRef as Co}from"react";import kt,{css as ia}from"styled-components";import{faAngleDown as aa}from"@fortawesome/pro-regular-svg-icons";import{jsx as $e,jsxs as pa}from"react/jsx-runtime";var pe=Co((e,o)=>$e(Rt,{...e,ref:o})),We=Co(({width:e,children:o,color:t="gray12",...r},n)=>pa(sa,{...r,$width:e,ref:n,children:[$e(g,{color:t,tag:"span",variant:"textSmPlus",children:o}),$e(Po,{color:"gray11",icon:aa,size:"sm"})]})),So=Co(({children:e,...o},t)=>$e(pe,{...o,asChild:!0,ref:t,children:$e(We,{color:"gray12",children:e})}));var Po=kt(x)``,sa=kt.button`
  ${({theme:e,$width:o})=>ia`
      all: unset;

      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 8px 12px;
      box-sizing: border-box;
      gap: 8px;
      background: ${e.colors.gray3};
      box-shadow: ${e.shadows.base}, inset 0 0 0 1px ${e.colors.gray7};
      border-radius: 8px;

      cursor: pointer;
      width: ${o??"initial"};

      ${Po} {
        transition: transform 200ms linear;
      }

      &[data-state="open"] {
        ${Po} {
          transform: rotate(180deg);
        }
      }
    `}
`;import{forwardRef as la}from"react";import{jsx as ca}from"react/jsx-runtime";var eg=la((e,o)=>ca(Se,{...e,ref:o}));import{forwardRef as da}from"react";import{Portal as ma}from"@radix-ui/react-dropdown-menu";import{jsx as Mt}from"react/jsx-runtime";var Ge=da(({container:e,maxHeight:o,minWidth:t,...r},n)=>Mt(ma,{container:e,children:Mt($t,{sideOffset:5,...r,$maxHeight:o,$minWidth:t,ref:n})}));import{forwardRef as ga}from"react";import{jsx as Dt,jsxs as Bt}from"react/jsx-runtime";var we=ga(({children:e,leadingIcon:o,trailingIcon:t,textColor:r,onClick:n,...a},i)=>Bt(wt,{...a,$textColor:r,onClick:s=>{s.stopPropagation(),n&&n(s)},ref:i,children:[Bt(vt,{children:[o?Dt(x,{color:"gray11",icon:o,size:"xs"}):null,e]}),t?Dt(x,{color:"gray11",icon:t,size:"xs"}):null]}));import{forwardRef as ve}from"react";import ce,{css as fa}from"styled-components";import{Table as ua,TableHead as ya,TableBody as xa,TableRow as ba,TableCell as ha}from"@mui/material";import{jsx as le}from"react/jsx-runtime";var Pg=ve(({layout:e="auto",bgColor:o="gray2",border:t=!0,...r},n)=>le(Ta,{children:le(Ia,{...r,$bgColor:o,ref:n,style:{tableLayout:e,border:t?void 0:"none",...r.style}})})),Cg=ve((e,o)=>le(Pa,{...e,ref:o})),Sg=ve((e,o)=>le(Ca,{...e,ref:o})),$g=ve(({height:e,...o},t)=>le(Sa,{...o,$height:e,ref:t})),wg=ve(({padding:e="12px 20px",...o},t)=>le($a,{...o,ref:t,style:{padding:e,...o.style}}));var Ta=ce.div`
  position: relative;
  box-sizing: border-box;
  background-clip: padding-box;
  width: 100%;
  max-width: 100%;
  overflow: auto;
`,Ia=ce(ua)`
  && {
    ${({theme:e,$bgColor:o})=>fa`
      height: fit-content;
      width: 100%;
      table-layout: fixed;
      background-color: ${e.colors[o]??o};
      border: 1px solid ${e.colors.gray6};
      border-radius: 8px;
      border-collapse: separate !important;
      overflow: hidden;

      // This entire segment of CSS properties here is to make sure that the last
      // row of a table does not have a border-bottom (it looks bad)
      th {
        ${e.styleSet.textSmPlus};
        color: ${e.colors.gray11};
        border-bottom: 1px solid ${e.colors.gray6};
      }

      td {
        ${e.styleSet.textSm};
        color: ${e.colors.gray11};
        border-bottom: 1px solid ${e.colors.gray6};
      }

      tr:last-child > td {
        border-bottom: none;
      }
    `}
  }
`,Pa=ce(ya)`
  && {
    th {
      padding: 16px 20px;
    }
  }
`,Ca=ce(xa)`
  && {
    td {
      padding: 12px 20px;
    }
  }
`,Sa=ce(ba)`
  ${({$height:e})=>e?`height: ${e}`:""};
`,$a=ce(ha)`
  && {
    border: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${e=>e.theme.colors.gray11};
  }
`;import{useEffect as ka,useState as Ma}from"react";import{forwardRef as wa}from"react";import zt,{css as va}from"styled-components";import*as L from"@radix-ui/react-tooltip";import{jsx as de,jsxs as Ft}from"react/jsx-runtime";var Xe=wa(({header:e,description:o,children:t,...r},n)=>{let{defaultOpen:a,open:i,onOpenChange:s,delayDuration:l=250,disableHoverableContent:p,container:c,arrow:d,placement:y,...m}=r,f={defaultOpen:a,open:i,onOpenChange:s,delayDuration:l,disableHoverableContent:p},h=typeof d=="boolean"?d&&{}:d;return de(L.TooltipProvider,{children:Ft(L.Root,{...f,children:[de(L.Trigger,{asChild:!0,children:t}),de(L.Portal,{container:c,children:Ft(Ra,{sideOffset:5,side:y,...m,ref:n,children:[e?de(g,{color:"gray12",tag:"h6",variant:"headingXs",children:e}):null,o?de(g,{color:"gray12",tag:"p",variant:"textXs",children:o}):null,h?de(Et,{...h}):null]})})]})})});var Ra=zt(L.Content)`
  ${({theme:e})=>va`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 4px;
    box-sizing: border-box;
    padding: 8px;
    border-radius: 6px;
    box-shadow: ${e.shadows.sm};
    background-color: ${e.colors.gray8};

    ${Et} {
      fill: ${e.colors.gray8};
    }
  `}
`,Et=zt(L.Arrow)``;import{jsx as Re,jsxs as Da}from"react/jsx-runtime";var Ot=({className:e,placeholder:o="Select...",defaultValue:t,value:r,options:n=[],triggerWidth:a="auto",disabled:i,onChange:s,...l})=>{let[p,c]=Ma(0);ka(()=>{let f=r??t;if(f!=null){let h=Math.max(0,Math.min(n.length-1,n.findIndex(I=>I.value===f)));c(h)}},[r,t,n]);let d=f=>()=>{c(f),s==null||s(n[f].value)},[y,m]=n.length>0&&p>=0&&p<n.length?[n[p].label??n[p].value,"gray12"]:[o,"gray11"];return Da(He,{children:[Re(So,{className:e,color:m,disabled:i,width:a,children:y}),n.length>0&&Re(Ge,{sideOffset:5,...l,children:n.map(({value:f,label:h,tooltipText:I,...k},u)=>I?Re(Xe,{description:I,children:Re(we,{...k,onSelect:d(u),children:h??f})},u):Re(we,{...k,onSelect:d(u),children:h??f},u))})]})};import{forwardRef as Ba}from"react";import Q,{css as Lt}from"styled-components";import{jsx as Va}from"react/jsx-runtime";var Hg=Ba(({type:e="body-gray",text:o,children:t,...r},n)=>{let i={"mono-blue":Fa,"mono-gray":za,"mono-green":Aa,"mono-purple":Na,"body-gray":Ea,"body-purple":Oa,"body-blue":La}[e];return Va(i,{...r,ref:n,children:t??o})});var ee=Lt`
  border-radius: 4px;
  height: max-content;
  width: max-content;
  ${e=>e.onClick&&Lt`
      cursor: pointer;
      :hover {
        opacity: 0.8;
      }
    `}
`,Fa=Q.div`
  ${e=>e.theme.styleSet.mono2Xs};
  color: white;
  background-color: ${e=>e.theme.colors.blue500};
  padding: 2px 4px 2px 4px;
  ${ee}
`,za=Q.div`
  ${e=>e.theme.styleSet.mono2Xs};
  color: ${e=>e.theme.colors.gray300};
  background-color: ${e=>e.theme.colors.gray700};
  padding: 2px 4px 2px 4px;
  ${ee}
`,Ea=Q.div`
  ${e=>e.theme.styleSet.text2Xs};
  color: ${e=>e.theme.colors.gray11};
  background-color: ${e=>e.theme.colors.gray7};
  padding: 1px 8px 1px 8px;
  ${ee}
`,Oa=Q.div`
  ${e=>e.theme.styleSet.text2Xs};
  color: white;
  background-color: ${e=>e.theme.colors.purple500};
  padding: 1px 8px 1px 8px;
  ${ee}
`,La=Q.div`
  ${e=>e.theme.styleSet.text2Xs};
  color: white;
  background-color: ${e=>e.theme.colors.blue500};
  padding: 1px 8px 1px 8px;
  ${ee}
`,Aa=Q.div`
  ${e=>e.theme.styleSet.mono2Xs};
  color: ${e=>e.theme.colors.white};
  background-color: ${e=>e.theme.colors.green500};
  padding: 2px 4px 2px 4px;
  ${ee}
`,Na=Q.div`
  ${e=>e.theme.styleSet.mono2Xs};
  color: white;
  background-color: ${e=>e.theme.colors.purple500};
  padding: 2px 4px 2px 4px;
  ${ee}
`;import{forwardRef as me}from"react";import Ue,{css as $o}from"styled-components";import{Input as Ha,inputClasses as _e}from"@mui/base/Input";import{TextareaAutosize as Wa}from"@mui/base/TextareaAutosize";import{faSearch as Ga}from"@fortawesome/pro-regular-svg-icons";import{jsx as X}from"react/jsx-runtime";var Xa=me(({fullWidth:e,width:o,ownerState:t,style:r,...n},a)=>X(ja,{...n,ref:a,style:{width:e?"100%":o,...r}})),_a=me(({ownerState:e,...o},t)=>X(Za,{...o,ref:t})),Ua=me(({ownerState:e,...o},t)=>X(Ka,{...o,ref:t})),Nt=({inputRef:e,width:o,fullWidth:t,slots:r,onKeyDown:n,...a})=>X(Ha,{...a,fullWidth:t,onKeyDown:i=>{i.key==="Enter"&&i.preventDefault(),n==null||n(i)},slotProps:{root:{style:{height:a.multiline?void 0:"36px"}},input:{ref:e}},slots:{root:Xa,input:_a,textarea:Ua,...r},width:o}),wo=me(({startAdornment:e,endAdornment:o,...t},r)=>X(Nt,{...t,endAdornment:o?X(At,{style:{paddingRight:"12px"},children:o}):void 0,inputRef:r,startAdornment:e?X(At,{style:{paddingLeft:"12px"},children:e}):void 0})),Jg=me((e,o)=>X(wo,{...e,ref:o,startAdornment:X(x,{icon:Ga,size:"xs"}),type:"search"})),qg=me(({rows:e,minRows:o,maxRows:t,...r},n)=>X(Nt,{...r,inputRef:n,maxRows:e??t,minRows:e??o,multiline:!0}));var ja=Ue.div`
  ${({theme:e})=>$o`
      outline: none;
      border: none;

      ${e.styleSet.textSm};

      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      box-sizing: border-box;
      width: 100%;
      overflow: hidden;

      background-color: ${e.colors.gray3};
      border: 1px solid ${e.colors.gray7};
      border-radius: 8px;
      color: ${e.colors.gray12};

      &:hover {
        background-color: ${e.colors.gray4};
        border: 1px solid ${e.colors.gray8};
      }

      &.${_e.disabled} {
        color: ${e.colors.gray11};
      }

      &.${_e.focused} {
        background-color: ${e.colors.gray4};
        border: 1px solid ${e.colors.blue9};
        box-shadow: 0px 0px 0px 2px ${e.colors.blue7};
      }

      &.${_e.error} {
        color: ${e.colors.red11};

        &.${_e.focused} {
          border: 1px solid ${e.colors.red9};
          box-shadow: 0px 0px 0px 2px ${v(e.colors.red7,.25)};
        }
      }
    `}
`,Vt=$o`
  ${({theme:e})=>$o`
    font: inherit;
    padding: 8px 12px;
    flex-grow: 1;
    background: inherit;
    border: none;
    border-radius: inherit;
    color: inherit;
    outline: 0;

    &::placeholder {
      color: ${e.colors.gray11};
    }

    &:disabled {
      opacity: 0.5;
    }
  `}
`,Za=Ue.input`
  ${Vt};

  &[type="search"]::-webkit-search-cancel-button {
    -webkit-appearance: none;
  }
`,Ka=Ue(Wa)`
  ${Vt};
  resize: vertical;
`,At=Ue.div`
  display: flex;
  height: 100%;
  box-sizing: border-box;
  align-items: center;
`;import{forwardRef as Ht}from"react";import Ya,{css as Ja}from"styled-components";import{Root as qa,Item as Qa,Indicator as es}from"@radix-ui/react-radio-group";import{faCheck as os}from"@fortawesome/pro-solid-svg-icons";import{jsx as je}from"react/jsx-runtime";var sf=Ht(({style:e,gap:o="12px",...t},r)=>je(qa,{...t,ref:r,style:{gap:o,display:"flex",flexDirection:"column",...e}})),pf=Ht((e,o)=>je(ts,{...e,ref:o,children:je(es,{children:je(x,{color:"gray12",icon:os,size:"xxxs"})})}));var ts=Ya(Qa)`
  ${({theme:e})=>Ja`
      all: unset;
      display: flex;
      width: 13px;
      height: 13px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      border-radius: 13px;
      border-style: solid;
      border-width: 1.25px;
      border-color: ${e.colors.gray9};

      &:hover {
        border-color: ${e.colors.gray10};
        background-color: ${e.colors.gray4};
      }

      &[data-state="checked"] {
        border-color: ${e.colors.blue9};
        background-color: ${e.colors.blue9};

        &:hover {
          border-color: ${e.colors.blue10};
          background-color: ${e.colors.blue10};
        }
      }
    `}
`;import{forwardRef as rs,useState as ns}from"react";import is,{css as as}from"styled-components";import{Root as ss,Indicator as ps}from"@radix-ui/react-checkbox";import{faCheck as ls,faMinus as cs}from"@fortawesome/pro-solid-svg-icons";import{jsx as vo,jsxs as ms}from"react/jsx-runtime";var yf=rs(({checked:e,onCheckedChange:o,...t},r)=>{let[n,a]=ns(e);return vo(ds,{...t,checked:n,onCheckedChange:s=>{a(s),o&&o(s)},ref:r,children:ms(ps,{children:[n===!0&&vo(x,{color:"white",icon:ls,size:"xxxs"}),n==="indeterminate"&&vo(x,{color:"white",icon:cs,size:"xxxs"})]})})});var ds=is(ss)`
  ${({theme:e})=>as`
      all: unset;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 13px;
      height: 13px;

      border-radius: 4px;
      border-width: 1.25px;
      border-style: solid;

      &[data-state="unchecked"] {
        background-color: transparent;
        border-color: ${e.colors.gray9};

        &:hover {
          background-color: ${e.colors.gray4};
          border-color: ${e.colors.gray10};
        }

        &[data-disabled] {
          opacity: 0.5;
          background-color: transparent;
          border-color: ${e.colors.gray9};
        }
      }

      &[data-state="checked"],
      &[data-state="indeterminate"] {
        background-color: ${e.colors.blue9};
        border-color: ${e.colors.blue9};

        &:hover {
          background-color: ${e.colors.blue10};
          border-color: ${e.colors.blue10};
        }

        &[data-disabled] {
          background-color: ${e.colors.gray9};
          border-color: ${e.colors.gray9};
        }
      }

      &[data-disabled] {
        opacity: 0.5;
      }
    `}
`;import{forwardRef as gs}from"react";import Ke from"styled-components";import{faCircleInfo as fs}from"@fortawesome/pro-regular-svg-icons";import{jsx as Ze,jsxs as Wt}from"react/jsx-runtime";var Gt=gs(({gap:e="24px",maxWidth:o,style:t,...r},n)=>Ze(us,{...r,ref:n,style:{gap:e,maxWidth:o,...t}})),ge=({children:e,label:o,maxWidth:t,info:r,id:n,...a})=>Wt(ys,{...a,style:{maxWidth:t,...a.style},children:[o?Wt(xs,{children:[Ze(bs,{id:n,children:o}),r?Ze(Xe,{description:r,placement:"right",children:Ze(x,{color:"gray11",icon:fs,size:"xxs"})}):null]}):null,e]});var us=Ke.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  box-sizing: border-box;
  width: 100%;
`,ys=Ke.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 12px;
  width: 100%;
`,xs=Ke.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`,bs=Ke(g).attrs({tag:"label",variant:"textSmPlus",color:"gray12"})``;import{forwardRef as hs,useMemo as Ts}from"react";import _t,{css as Is}from"styled-components";import{faInfoCircle as Ps}from"@fortawesome/pro-regular-svg-icons";import{jsx as Ro,jsxs as Xt}from"react/jsx-runtime";var zf=hs(({header:e,description:o,calloutTheme:t="warning",icon:r=Ps,...n},a)=>{let i=Ce(),s=Ts(()=>({warning:{color:i.colors.yellow11,borderColor:v(i.colors.yellow11,.32),backgroundColor:v(i.colors.yellow11,.08)},danger:{color:i.colors.red11,borderColor:v(i.colors.red11,.32),backgroundColor:v(i.colors.red11,.08)},success:{color:i.colors.green11,borderColor:v(i.colors.green11,.32),backgroundColor:v(i.colors.green11,.08)},info:{color:i.colors.violet11,borderColor:v(i.colors.violet11,.32),backgroundColor:v(i.colors.violet11,.08)}}),[i]),{color:l,borderColor:p,backgroundColor:c}=s[t];return Xt(Cs,{...n,ref:a,style:{color:l,backgroundColor:c,boxShadow:`inset 0 0 0 1px ${p}`,...n.style},children:[Ro(x,{icon:r,size:"xs"}),Xt(Ss,{children:[Ro(g,{color:l,tag:"h6",variant:"headingSm",children:e}),Ro(g,{color:l,tag:"p",variant:"textSm",children:o})]})]})});var Cs=_t.div`
  ${({theme:e})=>Is`
    display: flex;
    flex-direction: row;
    gap: 12px;
    align-items: center;
    justify-content: flex-start;
    padding: ${e.spacing.s3};
    border-radius: 8px;
    width: 100%;
    box-sizing: border-box;
  `}
`,Ss=_t.div``;import{createContext as $s,forwardRef as ws,useCallback as Ut,useMemo as vs,useReducer as Rs,useState as ks}from"react";import Ye,{css as jt}from"styled-components";import{faAngleLeft as Ms}from"@fortawesome/pro-regular-svg-icons";import{jsx as ko}from"react/jsx-runtime";var Mo=$s({onActiveRouteChange:()=>{},toggleSubMenuAtKey:()=>{},isExpandedAtKey:()=>!1}),Ds=({children:e,defaultRoute:o,route:t,onRouteSelected:r})=>{let[n,a]=ks(o),[i,s]=Rs((c,d)=>({...c,[d]:!(c[d]??!1)}),{}),l=Ut(c=>i[c]??!1,[i]),p=Ut(c=>{r==null||r(c),t==null&&a(c)},[t,r]);return ko(Mo.Provider,{value:vs(()=>({activeRoute:t??n,onActiveRouteChange:p,toggleSubMenuAtKey:s,isExpandedAtKey:l}),[t,n,l,p]),children:e})},Zt=ws(({width:e="240px",route:o,defaultRoute:t,onRouteSelected:r,...n},a)=>ko(Ds,{route:o,defaultRoute:t,onRouteSelected:r,children:ko(Bs,{...n,ref:a,style:{width:e,...n.style}})})),Bs=Ye.nav`
  ${({theme:e})=>{var o,t;return jt`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    padding: 20px 12px;
    gap: 10px;
    height: 100%;
    background-color: ${(o=e.colors)==null?void 0:o.gray1};
    border-right: 1px solid ${(t=e.colors)==null?void 0:t.gray6};
  `}}
`,Kt=Ye.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;
  width: 100%;
`,Yt=Ye(F).attrs({icon:Ms,buttonTheme:"secondary",variant:"inline",text:"Back"})`
  && {
    height: 36px;
    padding: 0px 12px;
  }
`,Jt=Ye.hr`
  ${({theme:e})=>{var o;return jt`
      all: unset;
      display: flex;
      height: 1px;
      width: 100%;
      background-color: ${(o=e.colors)==null?void 0:o.gray6};
      margin: 6px 0;
    `}}
`;import{faAngleDown as zs}from"@fortawesome/pro-solid-svg-icons";import{useContext as Es,useEffect as Os,useState as Ls}from"react";import ue,{css as fe}from"styled-components";var Fs={normal:"8px 12px",small:"6px 12px"},qt=fe`
  ${({theme:e,$selected:o,$size:t})=>fe`
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      border-radius: 8px;
      user-select: none;
      cursor: pointer;

      padding: ${Fs[t]};
      color: ${e.colors.gray11};

      &:hover {
        background-color: ${e.colors.gray4};
        box-shadow: inset 0 0 0 1px ${e.colors.gray8};
        color: ${e.colors.gray12};
      }
      &:active {
        background-color: ${e.colors.gray5};
        box-shadow: inset 0 0 0 1px ${e.colors.gray8};
        color: ${e.colors.gray12};
      }

      ${o&&fe`
        background-color: ${e.colors.gray3};
        box-shadow: inset 0 0 0 1px ${e.colors.gray7};
        color: ${e.colors.gray12};
      `}
    `}
`,Qt=ue.a`
  ${qt}
  text-decoration: none;
`,Do=ue.div`
  ${qt}
`,er=ue.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  color: inherit;
  flex-grow: 1;
`,or=ue(x)`
  ${({$open:e})=>fe`
    transition: transform 0.2s linear;
    ${e?fe`
          transform: rotate(180deg);
        `:void 0}
  `}
`,tr=ue.div`
  display: flex;
  padding: 0px 0px 0px calc(12px + 7.5px);
  gap: 4px;
  width: 100%;
`,rr=ue.div`
  ${({theme:e})=>fe`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 4px;
    padding: 0px 0px 0px 6.5px;
    box-shadow: -1px 0px 0px 0px ${e.colors.gray6};
  `}
`;import{Fragment as As,jsx as j,jsxs as Bo}from"react/jsx-runtime";var nr=({label:e,route:o,icon:t,options:r,initialExpanded:n=!1,size:a,...i})=>{let{activeRoute:s,onActiveRouteChange:l}=Es(Mo),[p,c]=Ls(n);Os(()=>{c(m=>(r==null?void 0:r.some(f=>f.route===s))||m)},[s,r]);let d=()=>Bo(er,{children:[t?j(x,{color:"gray11",icon:t,size:"xs"}):null,j(g,{tag:"label",variant:"textSmPlus",children:e})]});return o?j(Qt,{$selected:s===o,$size:a,href:o,onClick:m=>{var f;m.metaKey||m.ctrlKey||m.shiftKey||(m.preventDefault(),l(o),(f=i.onClick)==null||f.call(i,m))},...i,children:d()}):r?Bo(As,{children:[Bo(Do,{$size:a,onClick:()=>c(m=>!m),children:[d(),j(or,{$open:p,color:"gray11",icon:zs,size:"xs"})]}),p&&r.length>0?j(tr,{children:j(rr,{children:r.map(({size:m,...f},h)=>j(nr,{...f,size:"small"},h))})}):void 0]}):j(Do,{$size:a,...i,children:d()})},ir=e=>j(nr,{...e,size:"normal"});var tu={Nav:Zt,Group:Kt,Item:ir,Back:Yt,Divider:Jt};import{useEffect as js,useRef as Zs,useState as Ks}from"react";import Eo,{css as sr}from"styled-components";import Ys from"typewriter-effect";import Js from"highlight.js";import"highlight.js/styles/base16/tomorrow-night.css";import{faClipboard as qs}from"@fortawesome/pro-regular-svg-icons";import{forwardRef as Ns,useEffect as Vs,useRef as Hs,useState as Ws}from"react";import{faCheck as Gs,faCopy as Xs}from"@fortawesome/pro-regular-svg-icons";import _s from"styled-components";import{jsx as Fo}from"react/jsx-runtime";var ar=Ns(({className:e,text:o,icon:t=Xs,...r},n)=>{let a=Hs(null),[i,s]=Ws(!1);return Vs(()=>{let p=a.current;return()=>{p&&clearTimeout(p)}},[]),Fo(Us,{className:e,children:i?Fo(x,{color:"green11",icon:Gs,size:"xs"}):Fo(z,{buttonTheme:"secondary",variant:"inline",icon:t,size:"xs",...r,onClick:(p=>async()=>{await navigator.clipboard.writeText(p),s(!0),a.current=setTimeout(()=>{s(!1)},2500)})(o),ref:n})})});var Us=_s.div`
  display: inline-flex;
  white-space: nowrap;
  flex-shrink: 0;
  flex-direction: row;
  justify-content: center;
  width: fit-content;
  height: fit-content;
  align-items: center;
  box-sizing: border-box;
  overflow: hidden;
`;import{jsx as zo,jsxs as tp}from"react/jsx-runtime";var pr=({className:e,language:o,content:t,enableCopy:r=!0,fontVariant:n="monoXs",typeWriterEffect:a=!1})=>{let i=Zs(null),[s,l]=Ks("");return js(()=>{if(t&&t.length>0){let p=document.createElement("code");p.classList.add(o),p.classList.add("hljs"),p.textContent=o.includes("shell")?`$ ${t.trim()}`:t.trim(),Js.highlightElement(p),a?l(p.innerHTML):i.current&&(i.current.innerHTML="",i.current.appendChild(p))}},[t,o,a]),tp(Qs,{className:e,children:[zo(op,{$fontVariant:n,ref:i,children:a?zo(Ys,{onInit:p=>{p.typeString(s).start()},options:{delay:.3,autoStart:!0,wrapperClassName:`Typewriter__wrapper hljs ${o}`}}):null}),r&&t?zo(ep,{icon:qs,text:t}):null]})};var Qs=Eo.div`
  ${({theme:e})=>sr`
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      padding: 12px 16px;
      box-sizing: border-box;
      isolation: isolate;
      width: 100%;
      min-height: 46px;
      background-color: ${e.colors.gray2};
      border: 1px solid ${e.colors.gray6};
      border-radius: 8px;
      gap: 8px;
    `}
`,ep=Eo(ar)`
  && {
    margin-top: 3.5px;
    flex-shrink: 0;
    white-space: nowrap;
  }
`,op=Eo.pre`
  && {
    ${({theme:e,$fontVariant:o="monoXs"})=>sr`
        position: relative;
        width: 100%;
        box-sizing: border-box;
        padding: 0;
        margin: 0;
        background-color: inherit;
        overflow: auto;

        .hljs {
          display: inline;
          background: transparent;
          padding: 0;
          ${e.styleSet[o]};
        }

        .Typewriter__cursor {
          display: inline;
          color: #d9d9d9;
        }
      `}
  }
`;import{forwardRef as rp}from"react";import ke,{css as qe}from"styled-components";import{faMultiply as np}from"@fortawesome/pro-regular-svg-icons";import{jsx as ye,jsxs as Je}from"react/jsx-runtime";var $u=rp(({content:e,enableCopy:o,tabs:t=[],activeTab:r,language:n="language-python",typeWriterEffect:a=!1,...i},s)=>Je(ip,{...i,ref:s,children:[Je(ap,{children:[Je(Oo,{children:[ye(Lo,{}),ye(Lo,{}),ye(Lo,{})]}),t.map(l=>Je(Oo,{$active:r===l,children:[l,ye(x,{color:"gray11",icon:np,size:"xs"})]},l)),ye(Oo,{})]}),ye(sp,{content:e,enableCopy:o,fontVariant:"monoSm",language:n,typeWriterEffect:a})]}));var ip=ke.div`
  ${({theme:e})=>qe`
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 0px;
      box-sizing: border-box;
      background-color: ${e.colors.gray2};
      border: 1px solid ${e.colors.gray8};
      border-radius: 8px;
      overflow: hidden;
    `}
`,ap=ke.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  width: 100%;
  height: 48px;
`,Oo=ke.div`
  ${({theme:e,$active:o})=>qe`
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 12px 16px;
      gap: 6px;
      height: 100%;
      color: ${e.colors.gray12};
      border-right: 1px solid ${e.colors.gray8};
      border-bottom: ${o?void 0:`1px solid ${e.colors.gray8}`};
      ${e.styleSet.monoSm};

      &:last-of-type {
        width: 100%;
        flex-grow: 1;
        border-right: none;
      }
    `}
`,Lo=ke.div`
  ${({theme:e})=>qe`
      flex-shrink: 0;
      white-space: nowrap;
      width: 9px;
      height: 9px;
      border-radius: 50%;
      background-color: ${e.colors.gray10};
    `}
`,sp=ke(pr)`
  && {
    ${({theme:e})=>qe`
        padding: 16px;
        border: none;
        border-radius: 0;
        background: transparent;
        ${e.styleSet.monoSm};
      `}
  }
`;import{useState as pp}from"react";import lp from"styled-components";import{faAngleLeft as cp,faAngleRight as dp}from"@fortawesome/pro-regular-svg-icons";import{Fragment as gp,jsx as Ao,jsxs as No}from"react/jsx-runtime";var Fu=({defaultPage:e,page:o,count:t,hasPrev:r=!1,hasNext:n=!1,getPrevPage:a,getNextPage:i})=>{let[s,l]=pp(o??e??1),p=()=>{l(m=>Math.max(1,m-1)),a&&a()},c=()=>{l(m=>t?Math.min(t,m+1):m+1),i&&i()},d=r||s>1,y=n||t&&s<t;return No(mp,{children:[Ao(z,{buttonTheme:"secondary",disabled:!d,icon:cp,onClick:p,variant:"ghost"}),No(g,{color:"gray11",tag:"span",variant:"textSmPlus",children:[Ao(g,{color:"gray12",tag:"span",variant:"textSmPlus",children:s}),t!=null&&No(gp,{children:[" / ",t??1]})]}),Ao(z,{buttonTheme:"secondary",disabled:!y,icon:dp,onClick:c,variant:"ghost"})]})};var mp=lp.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 16px;
  margin: 0 auto;
`;import{Children as lr,cloneElement as fp,isValidElement as up}from"react";import xe,{css as dr}from"styled-components";import{jsx as Qe,jsxs as cr}from"react/jsx-runtime";var Au=({children:e,...o})=>{let t=lr.toArray(e);return Qe(hp,{...o,children:lr.map(t,(r,n)=>{if(!up(r))return null;let a=n===t.length-1;return cr(mr,{children:[cr(yp,{children:[Qe(xp,{children:n+1}),!a&&Qe(bp,{})]}),Qe(gr,{children:fp(r)})]})})})};var mr=xe.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 16px;
  width: 100%;
`,yp=xe.div`
  display: grid;
  grid-template-rows: auto 1fr;
  justify-items: center;
  grid-gap: 8px;
`,xp=xe.label`
  ${({theme:e})=>dr`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px;
    color: ${e.colors.gray12};
    flex-shrink: 0;

    ${e.styleSet.headingXs};
    line-height: 16px;

    width: 28px;
    height: 28px;
    background-color: ${e.colors.gray3};
    border: 1px solid ${e.colors.gray6};
    border-radius: 8px;
  `}
`,bp=xe.div`
  ${({theme:e})=>dr`
    width: 1px;
    background-color: ${e.colors.gray6};
  `}
`,gr=xe.div`
  position: relative;
  display: flex;
  box-sizing: border-box;
  padding: 4px 0px 0px;
  margin-bottom: 24px;
  width: 100%;
  min-width: 0;
`,hp=xe.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  width: 100%;

  ${mr}:last-child > ${gr} {
    margin-bottom: 0;
  }
`;import ur from"styled-components";import{Fragment as Pp,jsx as eo,jsxs as fr}from"react/jsx-runtime";var Gu=({title:e,descriptions:o,children:t,...r})=>fr(Tp,{...r,children:[fr(Ip,{children:[eo(g,{color:"gray12",tag:"h4",variant:"headingSm",children:e}),Array.isArray(o)?eo(Pp,{children:o.map((a,i)=>eo(g,{color:"gray11",tag:"p",variant:"textSm",children:a},i))}):typeof o=="function"?o():eo(g,{color:"gray11",tag:"p",variant:"textSm",children:o})]}),t]});var Tp=ur.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  gap: 12px 48px;
`,Ip=ur.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 6px;
`;import{forwardRef as Cp}from"react";import Vo,{css as Sp}from"styled-components";import{faTimes as $p}from"@fortawesome/pro-regular-svg-icons";import{jsx as yr,jsxs as oo}from"react/jsx-runtime";var Ju=Cp(({id:e,name:o,label:t,message:r,ctaButtonConfig:n,onDismiss:a,...i},s)=>oo(wp,{...i,ref:s,children:[oo(vp,{children:[oo(g,{color:"gray12",tag:"p",variant:"textSm",children:[t?oo(g,{tag:"span",variant:"textSmPlus",children:[t," "]}):null,r]}),n!=null&&n.text?yr(F,{buttonTheme:"info",height:28,onClick:n.onClick,children:n.text}):null]}),a&&yr(Rp,{buttonTheme:"secondary",icon:$p,onClick:()=>a(e,o),variant:"inline"})]}));var wp=Vo.div`
  ${({theme:e})=>Sp`
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 6px 24px;
      gap: 12px;
      isolation: isolate;
      width: 100%;
      background-color: ${e.colors.violet8};
    `}
`,vp=Vo.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex: 1;
`,Rp=Vo(z)`
  color: ${({theme:e})=>e.colors.gray12};
`;import{useState as ro,useEffect as Fp,useRef as Ir}from"react";import oe,{css as to}from"styled-components";import{Root as kp,List as Mp,Trigger as Dp,Content as Bp}from"@radix-ui/react-tabs";var xr=oe(kp)`
  ${({$gap:e=16,orientation:o="horizontal"})=>to`
      display: flex;
      align-items: flex-start;
      padding: 0;
      gap: ${e}px;
      width: 100%;
      max-height: 100%;
      flex-direction: ${o==="horizontal"?"column":"row"};

      ${Ho} {
        flex-direction: ${o==="horizontal"?"row":"column"};
      }
    `}
`,Ho=oe(Mp)`
  ${({$px:e=0,$currentTabX:o})=>to`
      position: relative;
      display: flex;
      align-items: flex-start;
      padding: 0 ${e}px;
      gap: 8px;
      z-index: 0;
      width: 100%;

      ${Wo} {
        transform-origin: ${e}px 0;
        transform: translateX(${o}px);
      }
    `}
`,ny=oe(pe)`
  && {
    margin-left: auto;
    margin-right: 0;
  }
`,br=oe(Ot)`
  && {
    margin-left: auto;
    margin-right: 0;
  }
`,hr=oe(Dp)`
  ${({theme:e})=>to`
      all: unset;
      position: relative;
      z-index: 2;
      display: inline-block;
      ${e.styleSet.textSmPlus};
      white-space: nowrap;
      min-width: fit-content;
      width: fit-content;
      box-sizing: border-box;
      box-shadow: ${e.shadows.base};
      border-radius: 6px;
      overflow: hidden;
      cursor: pointer;

      height: 36px;
      padding: 0px 12px;
      background-color: transparent;
      color: ${e.colors.gray11};

      &:hover,
      &:active,
      &[data-state="active"] {
        color: ${e.colors.gray12};
      }
    `}
`,Wo=oe.span`
  ${({theme:e,$width:o})=>to`
      position: absolute;
      height: 36px;
      width: ${o}px;
      padding: 0px 11px;
      box-sizing: border-box;
      border-radius: 6px;
      z-index: 1;
      background-color: ${e.colors.gray3};
      box-shadow: ${e.shadows.base}, inset 0 0 0 1px ${e.colors.gray7};
      transition: transform 100ms linear;
    `}
`,Tr=oe(Bp)`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
`;import{Fragment as zp,jsx as Me,jsxs as Pr}from"react/jsx-runtime";var py=({className:e,tabs:o,px:t=0,gap:r=16,orientation:n="horizontal"})=>{let a=Ir(null),i=Ir([]),[s,l]=ro(0),[p,c]=ro(0),[d,y]=ro(0),[m,f]=ro(0);Fp(()=>{let u=o[s],b=i.current[s],w=a.current;if(w&&b&&u){let R=b.getBoundingClientRect(),T=w.getBoundingClientRect();f(R.left-T.left-t),y(R.width)}},[o,t,s]);let h=u=>{c(0),l(parseInt(u))},I=o.map(({name:u,contents:b},w)=>{let R=u,T=b;if(Array.isArray(b)){let C=w===s?p:0;R=b.length>0?`${u}-${b[C].type}`:void 0,T=b.length>0?b[C].component:void 0}if(R)return{value:w,label:u,component:T}}).filter(u=>u!==void 0),k=Array.isArray(o[s].contents)?o[s].contents.map(({type:u,component:b,...w},R)=>({value:R,label:u,...w})):void 0;return Me(xr,{$gap:r,className:e,onValueChange:h,orientation:n,value:s.toString(),children:I.length>0&&Pr(zp,{children:[Pr(Ho,{$currentTabX:m,$px:t,ref:a,children:[I.map(({value:u,label:b},w)=>Me(hr,{asChild:!1,ref:R=>R&&(i.current[w]=R),value:u.toString(),children:b},w)),d>0&&Me(Wo,{$width:d}),k?Me(br,{align:"end",hideWhenDetached:!0,onChange:u=>{c(parseInt(u))},options:k,value:Math.max(0,Math.min(k.length-1,p))}):null]}),I.map(({value:u,component:b},w)=>Me(Tr,{value:u.toString(),children:typeof b=="function"?b():b},w))]})})};import{css as Cr}from"styled-components";import"react-toastify/dist/ReactToastify.css";import{faCircleInfo as Ep}from"@fortawesome/pro-solid-svg-icons";import{jsx as Op}from"react/jsx-runtime";var uy={limit:2,closeButton:!0,closeOnClick:!1,hideProgressBar:!0,pauseOnHover:!1,pauseOnFocusLoss:!1,position:"top-center",icon:Op(x,{color:"gray12",icon:Ep,size:"sm"}),className:"beam-ToastProvider",toastClassName:"beam-Toast",bodyClassName:"beam-ToastBody",progressClassName:"beam-ToastProgress"},yy=Cr`
  ${({theme:e})=>Cr`
    /* .beam-ToastProvider */
    width: max-content !important;

    --toastify-color-light: ${e.colors.gray12};
    --toastify-color-dark: ${e.colors.gray1};
    --toastify-color-info: ${e.colors.blue11};
    --toastify-color-success: ${e.colors.green11};
    --toastify-color-warning: ${e.colors.yellow11};
    --toastify-color-error: ${e.colors.red11};
    --toastify-color-transparent: rgba(255, 255, 255, 0.7);

    --toastify-icon-color-info: ${e.colors.gray12} !important;
    --toastify-icon-color-error: ${e.colors.gray12} !important;
    --toastify-icon-color-warning: ${e.colors.gray12} !important;
    --toastify-icon-color-success: ${e.colors.gray12} !important;
    --toastify-icon-color-error: ${e.colors.gray12} !important;

    .Toastify__toast--warning {
      background-color: ${e.colors.yellow9};
    }

    .Toastify__toast--success {
      background-color: ${e.colors.green9};
    }

    .Toastify__toast--info {
      background-color: ${e.colors.blue9};
    }

    .Toastify__toast--default {
      background-color: ${e.colors.blue9};
    }

    .Toastify__toast--error {
      background-color: ${e.colors.red9};
    }

    .Toastify__close-button > svg {
      fill: ${e.colors.white} !important;
    }

    .Toastify__close-button--light {
      opacity: 0.9;
    }

    /* .beam-Toast is passed to toastClassName */
    .beam-Toast {
      border-radius: 8px;
      min-height: 46px;
      min-width: 400px;
    }

    button[aria-label="close"] {
      display: flex;
      align-items: center;
      margin: auto;
      margin-right: 6px;
    }

    /* .beam-ToastBody is passed to bodyClassName */
    .beam-ToastBody {
      color: ${e.colors.white};
      ${e.styleSet.textSm};
      text-align: center;
    }

    /* .beam-ToastProgress is passed to progressClassName */
    .beam-ToastProgress {
      background: white;
      --toastify-color-progress-light: ${e.colors.white};
      width: 100%;
      height: 2px;
    }

    .progress-infinite-loading {
      background: white;
      --toastify-color-progress-light: ${e.colors.white};
      width: 50%;
      height: 2px;

      animation-duration: 1.5s !important;
      animation-name: infinite-progress-bar !important;
      animation-direction: reverse;
      animation-iteration-count: infinite;

      @keyframes infinite-progress-bar {
        0% {
          transform: translateX(200%);
        }
        100% {
          transform: translateX(-100%);
        }
      }
    }
  `}
`;import{faAngleRight as Lp}from"@fortawesome/pro-regular-svg-icons";import{Children as Sr,cloneElement as $r,forwardRef as Ap,isValidElement as Np}from"react";import De,{css as no}from"styled-components";import{jsx as te,jsxs as Xp}from"react/jsx-runtime";var $y=({href:e,...o})=>e?te(vr,{as:"a",...o,color:"gray12",href:e}):te(vr,{...o,color:"gray12"}),wy=Ap(({size:e="small",separatorIcon:o=Lp,separatorIconColor:t="gray11",separatorIconSize:r="sm",separatorImageSrc:n,separatorImageDimension:a="20px",children:i,...s},l)=>{let p=Sr.toArray(i);return te(Vp,{$size:e,...s,ref:l,children:Sr.map(p,(c,d)=>Np(c)?d===p.length-1?te(wr,{children:$r(c)}):Xp(wr,{children:[$r(c),te(Wp,{color:"gray11",tag:"span",children:n?te(Gp,{$dimension:a,alt:"separator",src:n}):te(x,{color:t,icon:o,size:r})})]}):null)})});var Vp=De.div`
  ${({theme:e,$size:o})=>no`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 0px;
    white-space: nowrap;
    overflow: hidden;
    width: fit-content;
    ${o==="small"?e.styleSet.headingSm:e.styleSet.headingLg}
    * {
      font: inherit;
    }
  `}
`,wr=De.div`
  display: flex;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 8px;

  &:first-child {
    flex: 0 0 auto;
    padding-left: 0;
  }

  flex: 0 1000 auto;

  &:last-child {
    flex: 0 0 auto;
  }

  &:hover {
    flex: 1 0 auto;
  }
`,Hp=no`
  ${({href:e,onClick:o})=>no`
    font: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    ${e||o?no`
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        `:null}
  `}
`,vr=De(g)`
  ${Hp}
`,Wp=De(g)`
  && {
    margin-left: 8px;
    display: flex;
    align-items: center;
  }
`,Gp=De.img`
  height: ${({$dimension:e})=>e};
  width: ${({$dimension:e})=>e};
  max-height: ${({$dimension:e})=>e};
  max-width: ${({$dimension:e})=>e};
`;import Xo from"styled-components";import{jsx as Go,jsxs as Zp}from"react/jsx-runtime";var Rr=({payload:e})=>Go(_p,{children:e==null?void 0:e.map(({color:o,value:t},r)=>Zp(Up,{children:[Go(jp,{color:o}),Go(g,{color:"gray11",variant:"textXs",children:t})]},`item-${r}`))});var _p=Xo.ul`
  display: flex;
  justify-content: center;
  gap: 16px;
  list-style: none;
  margin: 0;
  margin-top: 16px;
`,Up=Xo.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`,jp=Xo.div`
  background-color: ${e=>e.color};
  border-radius: 4px;
  width: 16px;
  height: 16px;
`;import be,{css as kr}from"styled-components";import{jsx as $,jsxs as Z}from"react/jsx-runtime";var Mr=({renderer:e,...o})=>{let{active:t=!0,label:r,payload:n,sortCompareFn:a,displayLabelFn:i,displayPayloadFn:s}=o;if(!t||!(n!=null&&n.length))return null;let l=a?n.sort(a):n;return e?e(o):Z(Dr,{children:[$(g,{color:"gray11",tag:"span",variant:"textSmPlus",children:(i==null?void 0:i(r))??r}),$(Br,{children:$("tbody",{children:l.map((p,c)=>Z("tr",{children:[$("td",{children:Z(_o,{children:[$(Fr,{$color:p.color}),$(g,{color:"gray12",tag:"span",variant:"textSmPlus",children:p.name||p.dataKey})]})}),$("td",{children:$(Uo,{children:(s==null?void 0:s(p.value,p.unit))||p.value})})]},c))})})]})},Ey=({renderer:e,...o})=>{let{active:t=!0,label:r,payload:n,sortCompareFn:a,displayLabelFn:i,displayPayloadFn:s,displayTotal:l=!1}=o;if(!t||!(n!=null&&n.length))return null;let p=Kp(n);if(!p)return null;let c=a?n.sort(a):n;return e?e(o):Z(Dr,{children:[$(g,{color:"gray11",tag:"span",variant:"textSmPlus",children:(i==null?void 0:i(r))??r}),$(Yp,{children:Z("tbody",{children:[c.map((d,y)=>{var m;return Z("tr",{children:[$("td",{children:Z(_o,{children:[$(Fr,{$color:d.color}),$("span",{children:d.name||d.dataKey})]})}),$("td",{children:$(Uo,{children:(s==null?void 0:s(d.value,d.unit))||((m=d.value)==null?void 0:m.toFixed(2))})})]},y)}),l?Z("tr",{children:[$("td",{children:$(_o,{children:"Total"})}),$("td",{children:$(Uo,{children:(s==null?void 0:s(p,c[0].unit))||p.toFixed(2)})})]}):null]})})]})};var Kp=e=>{let o=0;return e.forEach(t=>o+=t.value??0),o},Dr=be.div`
  ${({theme:e})=>kr`
      display: flex;
      /* max-width: 240px; */
      padding: 8px 12px;
      flex-direction: column;
      align-items: flex-start;
      gap: 6px;
      border-radius: 10px;
      background-color: ${e.colors.gray4};
      border: 1px solid ${e.colors.gray7};
      box-shadow: ${e.shadows.sm};
    `}
`,Br=be.table`
  border-collapse: collapse;

  td:first-of-type {
    padding-right: 12px;
  }

  tr:last-of-type td:first-of-type {
    float: right;
  }
`,Yp=be(Br)``,_o=be(g).attrs({color:"gray12",tag:"span",variant:"textSmPlus"})`
  display: flex;
  align-items: center;
  gap: 8px;
`,Uo=be(g).attrs({color:"gray11",tag:"span",variant:"textSm"})``,Fr=be.span`
  ${({theme:e,$color:o})=>kr`
    background-color: ${o??e.colors.gray11};
    width: 6px;
    height: 6px;
    border-radius: 50%;
  `}
`;import{Fragment as Jp}from"react";import*as P from"recharts";import qp,{css as Qp,useTheme as el}from"styled-components";import{jsx as D,jsxs as jo}from"react/jsx-runtime";var ol=({className:e,variant:o,isAnimationActive:t=!1,width:r="100%",height:n="100%",type:a,config:i,children:s,...l})=>{let p=el(),c=p.typography.styleSet.text.textXs,{grid:d=!1,xAxis:y,yAxis:m,tooltip:f,legend:h=!1,referenceLines:I=[]}=i??{},k=Be(d),u=Be(y),b=Be(m),w=Be(f),R=Be(h),T=o??(a==="area"?"gradient":"solid"),C=a==="area"?{cursor:{stroke:p.colors.gray9},wrapperStyle:{outline:"none"}}:{cursor:{fill:p.colors.gray7},wrapperStyle:{outline:"none"}},_=a==="area"?i==null?void 0:i.areas:a==="bar"?i==null?void 0:i.bars:[],U=a==="area"?P.AreaChart:a==="bar"?P.BarChart:void 0;return!U||!ol?null:D(tl,{$height:n,$width:r,children:D(P.ResponsiveContainer,{className:e,height:"100%",width:"100%",children:jo(U,{...l,children:[k?D(P.CartesianGrid,{stroke:p.colors.gray5,strokeDasharray:"3 3",...k}):null,u?D(P.XAxis,{domain:["dataMin","dataMax"],orientation:"bottom",stroke:p.colors.gray11,...u,style:{...c,...u.style}}):null,b?D(P.YAxis,{orientation:"left",stroke:p.colors.gray11,...b,style:{...c,...b.style}}):null,w?D(P.Tooltip,{content:D(Mr,{...w}),...C}):null,R?D(P.Legend,{content:D(Rr,{...R})}):null,I==null?void 0:I.map((A,Y)=>{let M=A.label?{fontFamily:q.typography.styleSet.text.textXs.fontFamily,fontSize:q.typography.styleSet.text.text2Xs.fontSize,fontWeight:q.typography.styleSet.text.text2Xs.fontWeight}:void 0;return D(P.ReferenceLine,{...A,label:A.label&&typeof A.label=="object"?{...A.label,style:M}:void 0},`reference-line-${Y}`)}),(_??[]).map(({ref:A,fill:Y="blue9",...M},re)=>{let Ie=`linear-gradient-${re}`,J=p.colors[Y]??Y,ot={type:"monotone",...M,fill:T==="gradient"?`url(#${Ie})`:J,isAnimationActive:t,stackId:"a",stroke:J};return jo(Jp,{children:[T==="gradient"&&D("defs",{children:jo("linearGradient",{id:Ie,x1:"0",x2:"0",y1:"0",y2:"1",children:[D("stop",{stopColor:J,stopOpacity:.32}),D("stop",{offset:"1",stopColor:J,stopOpacity:0})]})}),a==="area"?D(P.Area,{activeDot:{fill:"white",stroke:"white",r:3},...ot}):D(P.Bar,{...ot})]},re)}),s]})})})};var Be=e=>typeof e=="boolean"?e&&{}:e??{},tl=qp.div`
  ${({$width:e,$height:o})=>Qp`
    width: ${e};
    height: ${o};
  `}
`;import{faCalendar as ec,faTimes as oc}from"@fortawesome/pro-regular-svg-icons";import{parseAbsoluteToLocal as Kr}from"@internationalized/date";import{Root as tc,Trigger as rc}from"@radix-ui/react-popover";import nc from"classnames";import{format as go,isSameDay as ic}from"date-fns";import{forwardRef as Jr,useState as ac}from"react";import{useDateRangePicker as sc}from"react-aria";import{useDateRangePickerState as pc}from"react-stately";import fo,{css as Yo}from"styled-components";import{useRef as rl,useEffect as nl}from"react";var E=(e,o=null)=>{let t=rl(o);return nl(()=>{e&&(typeof e=="function"?e(t.current):e.current=t.current)},[e]),t};import{forwardRef as il}from"react";import{Portal as al,Content as sl}from"@radix-ui/react-popover";import pl,{css as ll}from"styled-components";import{jsx as zr}from"react/jsx-runtime";var io=il(({container:e,minWidth:o,...t},r)=>zr(al,{container:e,children:zr(cl,{$minWidth:o,ref:r,...t})})),cl=pl(sl)`
  ${({theme:e,$minWidth:o})=>ll`
    display: flex;
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;

    min-width: ${o};

    border-radius: 8px;
    border: 1px solid ${e.colors.gray6};
    background: ${e.colors.gray2};

    box-shadow: ${e.shadows.sm};
  `}
`;import{forwardRef as kl}from"react";import{useLocale as Ml,useRangeCalendar as Dl}from"react-aria";import{useRangeCalendarState as Bl}from"react-stately";import{createCalendar as Fl}from"@internationalized/date";import Wr from"styled-components";import{faChevronLeft as zl,faChevronRight as El}from"@fortawesome/pro-regular-svg-icons";import{forwardRef as bl}from"react";import{useCalendarGrid as hl,useLocale as Tl}from"react-aria";import{endOfMonth as Il,getWeeksInMonth as Pl}from"@internationalized/date";import Nr from"styled-components";import{forwardRef as dl}from"react";import{useCalendarCell as ml,useLocale as gl}from"react-aria";import{getDayOfWeek as fl,isSameDay as Er,isSameMonth as ul}from"@internationalized/date";import Lr,{css as ao}from"styled-components";import{jsx as Or}from"react/jsx-runtime";var Ar=dl(({className:e,state:o,currentMonth:t,...r},n)=>{let a=E(n),{cellProps:i,buttonProps:s,isSelected:l,isInvalid:p,formattedDate:c}=ml(r,o,a),{date:d}=r,{locale:y}=gl(),m=fl(d,y),f=t?!ul(t,d):void 0,h=o.highlightedRange?Er(d,o.highlightedRange.start):l,I=o.highlightedRange?Er(d,o.highlightedRange.end):l,k=l&&(h||m===0||d.day===1),u=l&&(I||m===6||d.day===d.calendar.getDaysInMonth(d));return Or(yl,{...i,className:e,children:Or(xl,{...s,$isRoundedLeft:k,$isRoundedRight:u,$isSelected:l,buttonTheme:p?"danger":l?"primary":"secondary",disabled:f,ref:a,size:"sm",variant:l?"solid":"ghost",width:"100%",children:c})})});var yl=Lr.td``,xl=Lr(F)`
  ${({$isSelected:e,$isRoundedLeft:o,$isRoundedRight:t})=>ao`
    aspect-ratio: 1/1;
    border-radius: 0px;

    ${!e&&ao`
      &:hover {
        border-radius: 8px;
      }
    `}

    && {
      ${o&&ao`
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
      `};
      ${t&&ao`
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
      `}
    }
  `}
`;import{jsx as K,jsxs as $l}from"react/jsx-runtime";var Vr=bl(({className:e,state:o,offset:t={},...r},n)=>{let{locale:a}=Tl(),i=o.visibleRange.start.add(t),s=Il(i),{gridProps:l,headerProps:p,weekDays:c}=hl({...r,startDate:i,endDate:s},o),d=Pl(o.visibleRange.start,a);return $l(Cl,{...l,cellPadding:"0",className:e,ref:n,children:[K("thead",{...p,children:K("tr",{children:c.map((y,m)=>K(Sl,{children:K(g,{color:"gray12",tag:"span",variant:"textSmPlus",children:y})},m))})}),K("tbody",{children:[...Array(d)].map((y,m)=>K("tr",{children:o.getDatesInWeek(m,i).map((f,h)=>f?K(Ar,{currentMonth:i,date:f,state:o},h):K("td",{},h))},m))})]})});var Cl=Nr.table`
  border-collapse: separate;
  border-spacing: 0px 4px;
`,Sl=Nr.th`
  height: 36px;
`;import{forwardRef as wl}from"react";import{useButton as vl}from"react-aria";import{jsx as Rl}from"react/jsx-runtime";var Zo=wl(({className:e,buttonTheme:o="secondary",icon:t,variant:r="inline",...n},a)=>{let i=E(a),{buttonProps:s}=vl(n,i),l={...s,className:e,buttonTheme:o,icon:t,variant:r};return Rl(z,{...l,className:e,ref:i})});import{jsx as so,jsxs as Hr}from"react/jsx-runtime";var Gr=kl(({className:e,...o},t)=>{let r=E(t),{locale:n}=Ml(),a=Bl({...o,locale:n,createCalendar:Fl}),{calendarProps:i,prevButtonProps:s,nextButtonProps:l,title:p}=Dl(o,a,r);return Hr(Ol,{...i,className:e,ref:r,children:[Hr(Ll,{children:[so(Zo,{...s,icon:zl,variant:"ghost"}),so(g,{color:"gray12",tag:"h3",variant:"titleBase",children:p}),so(Zo,{...l,icon:El,variant:"ghost"})]}),so(Vr,{state:a})]})});var Ol=Wr.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`,Ll=Wr.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;import{forwardRef as _r}from"react";import{useDateField as Xl,useLocale as _l}from"react-aria";import{useDateFieldState as Ul}from"react-stately";import{createCalendar as jl}from"@internationalized/date";import Ur,{css as jr}from"styled-components";import{Slot as Zl}from"@radix-ui/react-slot";import{forwardRef as Al}from"react";import{useDateSegment as Nl}from"react-aria";import Vl,{css as Xr}from"styled-components";import{jsx as Gl}from"react/jsx-runtime";var Hl=Al(({segment:e,state:o},t)=>{let r=E(t),{segmentProps:n}=Nl(e,o,r);return Gl(Wl,{$isEditable:e.isEditable,$isPlaceholder:e.isPlaceholder,...n,ref:r,style:{...n.style},children:e.text??e.placeholder})}),po=Hl,Wl=Vl.div`
  ${({theme:e,$isEditable:o})=>Xr`
    text-align: end;
    padding: 2px 4px;
    box-sizing: content-box;
    border-radius: 4px;
    outline: 2px solid transparent;
    outline-offset: 2px;

    &:focus {
      color: ${e.colors.gray12};
      background-color: ${e.colors.blue9};
    }

    ${!o&&Xr`
      color: ${e.colors.gray11};
      background-color: initial;
      padding: initial;
    `}
  `}
`;import{jsx as Fe}from"react/jsx-runtime";var lo=_r(({className:e,...o},t)=>{let r=E(t),{locale:n}=_l(),a=Ul({...o,locale:n,createCalendar:jl}),{fieldProps:i}=Xl({...o,"aria-label":"Date Input","aria-labelledby":"beam-DateInput"},a,r);return Fe(co,{children:Fe("div",{...i,"aria-label":`date-field-${i.id}`,"aria-labelledby":`date-field-${i.id}`,className:e,ref:r,children:a.segments.reduce((s,l,p)=>l.type!=="timeZoneName"?[...s,Fe(po,{segment:l,state:a},p)]:s,[])})})}),Kl=_r(({width:e,...o},t)=>Fe(Ko,{$width:e,children:Fe(lo,{...o,ref:t})}));var co=Ur(Zl)`
  ${({theme:e})=>jr`
      position: relative;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      overflow: hidden;
      background-color: transparent;
      color: ${e.colors.gray12};
      outline: none;
      border: none;
      ${e.styleSet.textSm};

      &[aria-disabled] {
        color: ${e.colors.gray11};
      }
    `}
`,Ko=Ur(co)`
  ${({theme:e,$width:o})=>jr`
      width: ${o};
      height: 36px;
      overflow: hidden;
      padding: 8px 12px;
      background-color: ${e.colors.gray3};
      box-shadow: inset 0 0 0 1px ${e.colors.gray7};
      border-radius: 8px;
      color: ${e.colors.gray12};

      &:hover {
        background-color: ${e.colors.gray4};
        box-shadow: inset 0 0 0 1px ${e.colors.gray8};
      }

      &[aria-disabled] {
        color: ${e.colors.gray11};
      }

      &:focus-within {
        background-color: ${e.colors.gray4};
        box-shadow: inset 0 0 0 1px ${e.colors.blue9}, 0px 0px 0px 2px ${e.colors.blue7};
      }
    `}
`;import{forwardRef as Zr}from"react";import{useLocale as Yl,useTimeField as Jl}from"react-aria";import{useTimeFieldState as ql}from"react-stately";import{jsx as ze}from"react/jsx-runtime";var Ql=Zr(({className:e,...o},t)=>{let r=E(t),{locale:n}=Yl(),a=ql({...o,locale:n}),{fieldProps:i}=Jl({...o,"aria-label":"Time Input","aria-labelledby":"beam-TimeInput"},a,r);return ze(co,{children:ze("div",{...i,"aria-label":`time-field-${i.id}`,"aria-labelledby":`time-field-${i.id}`,className:e,ref:r,children:a.segments.reduce((s,l,p)=>l.type!=="timeZoneName"?[...s,ze(po,{segment:l,state:a},p)]:s,[])})})}),mo=Zr(({width:e,...o},t)=>ze(Ko,{$width:e,children:ze(Ql,{...o,ref:t})}));import{Fragment as Yr,jsx as B,jsxs as he}from"react/jsx-runtime";var lc=Jr(({className:e,container:o,granularity:t="minute",labelType:r="text",children:n,triggerProps:a,placeholder:i="Date Range",value:s,onChange:l,...p},c)=>{var A,Y;let d=E(c),[y,m]=ac(),f=M=>{m(M),l==null||l(M)},h=M=>{M.stopPropagation(),f(null)},I=pc({...p,value:s??y,onChange:f,granularity:t}),{groupProps:k,startFieldProps:u,endFieldProps:b,buttonProps:w,calendarProps:R}=sc({...p,"aria-label":"Date Range Picker","aria-labelledby":"beam-DateRangePicker"},I,d),{width:T=r==="compact"?"fit-content":"350px",color:C,..._}=a??{},U=()=>{var Ie,J;let M={...u,granularity:t},re={...b,granularity:t};switch(r){case"input":return he(Yr,{children:[B(lo,{...M}),B(g,{children:"-"}),B(lo,{...re})]});case"asChild":return n==null?void 0:n({startFieldProps:M,endFieldProps:re});case"text":default:return B(g,{color:"gray12",tag:"span",variant:"textSm",children:cc((Ie=M.value)==null?void 0:Ie.toDate(),(J=re.value)==null?void 0:J.toDate(),i)})}};return he(tc,{children:[B(rc,{asChild:!0,children:he(dc,{$color:C,$width:T,..._,...k,className:nc(_.className,k.className,e),ref:d,tabIndex:0,children:[r!=="compact"&&he(Yr,{children:[B(mc,{children:U()}),B(z,{buttonTheme:"secondary",icon:oc,onClick:h,variant:"inline"})]}),B(gc,{children:B(x,{color:"gray11",icon:ec})})]})}),he(io,{container:o,sideOffset:5,children:[B(Gr,{...R}),he(fc,{children:[B(ge,{label:"Start time",children:B(mo,{onChange:M=>I.setTime("start",M),value:(A=I.timeRange)==null?void 0:A.start,width:"100%"})}),B(ge,{label:"End time",children:B(mo,{onChange:M=>I.setTime("end",M),value:(Y=I.timeRange)==null?void 0:Y.end,width:"100%"})})]})]})]})}),Pb=Jr(({dateRange:e=[],onDateRangeChange:o,...t},r)=>{let n=e[0]?Kr(e[0].toISOString()):void 0,a=e[1]?Kr(e[1].toISOString()):void 0;return n=n??a,a=a??n,B(lc,{...t,onChange:s=>{let{start:l,end:p}=s??{};l&&p?o==null||o([l.toDate(),p.toDate()]):o==null||o([])},ref:r,value:n&&a?{start:n,end:a}:void 0})});var cc=(e,o,t="Date Range")=>{let r=e?go(e,"MMM d, p"):void 0,n=o?go(o,"MMM d, p"):void 0;return r&&n?e&&o&&ic(e,o)?`${go(e,"MMM d, p")} - ${go(o,"p")}`:`${r} - ${n}`:r?`After ${r}`:n?`Before ${n}`:t},dc=fo.div`
  ${({theme:e,$width:o="fit-content",$color:t="gray12"})=>Yo`
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    overflow: hidden;
    background-color: ${e.colors.gray3};
    box-shadow: inset 0 0 0 1px ${e.colors.gray7};
    border-radius: 8px;
    width: ${o};
    color: ${e.colors[t]??t};
    height: 36px;
    justify-content: space-between;
    flex-shrink: 0;
    white-space: nowrap;
    overflow: hidden;

    &:hover {
      background-color: ${e.colors.gray4};
      box-shadow: inset 0 0 0 1px ${e.colors.gray8};
    }

    &:focus,
    &:focus-visible,
    &:focus-within {
      outline: unset;
      background-color: ${e.colors.gray4};
      box-shadow: inset 0 0 0 1px ${e.colors.blue9}, 0px 0px 0px 2px ${e.colors.blue7};
    }
  `}
`,mc=fo.div`
  ${({theme:e})=>Yo`
      position: relative;
      display: flex;
      gap: 8px;
      align-items: center;
      box-sizing: border-box;
      width: fit-content;
      height: 36px;
      padding: 8px 12px;
      color: ${e.colors.gray12};
      flex: 1;
    `}
`,gc=fo.div`
  ${({theme:e})=>Yo`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    white-space: nowrap;

    height: 34px;
    width: 34px;

    box-shadow: inset 1px 0 0 0 ${e.colors.gray7};

    &:hover {
      box-shadow: inset 1px 0 0 0 ${e.colors.gray8};
    }
  `}
`,fc=fo.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  gap: 16px;
`;import{forwardRef as Pc,useEffect as Cc,useState as Sc}from"react";import{useId as uc}from"react";import Jo from"styled-components";import{faCheck as yc}from"@fortawesome/pro-regular-svg-icons";import{jsx as qr,jsxs as Ic}from"react/jsx-runtime";var xc=e=>{let o=uc(),{className:t,textValue:r,disabled:n,onSelect:a,id:i,checked:s,onCheckedChange:l,children:p}=e;return Ic(bc,{className:t,disabled:n,onSelect:c=>{c.preventDefault(),a==null||a(c)},textValue:r,trailingIcon:s?yc:void 0,children:[qr(hc,{htmlFor:i??o,onClick:c=>{c.stopPropagation()}}),qr(Tc,{checked:s??!1,id:i??o,onChange:c=>l==null?void 0:l(c.target.checked)}),p]})},Qr=xc,bc=Jo(we)`
  position: relative;
  div:first-child {
    width: 100%;
    height: 100%;
  }
`,hc=Jo.label`
  all: unset;
  position: absolute;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
`,Tc=Jo.input.attrs({type:"checkbox"})`
  display: none;
  position: absolute;
  width: 0;
  height: 0;
`;import{jsx as qo,jsxs as $c}from"react/jsx-runtime";var Ab=Pc(({children:e,container:o,triggerAsChild:t,values:r=[],onValuesChange:n,options:a=[],className:i},s)=>{let l=r.reduce((y,m)=>({...y,[m]:{value:m,checked:!0}}),{}),[p,c]=Sc();Cc(()=>{if(p){let y=Object.entries(p).reduce((m,[f,{checked:h}])=>h?[...m,f]:m,[]);n==null||n(y)}},[p]);let d=y=>m=>{c(f=>({...f??l,[y]:{value:y,checked:m}}))};return $c(He,{children:[qo(pe,{asChild:t,children:e}),qo(Ge,{container:o,minWidth:"320px",ref:s,className:i,children:a.map(({value:y,children:m},f)=>{var h;return qo(Qr,{checked:!!((h=p==null?void 0:p[y])!=null&&h.checked)||r.includes(y),id:y,onCheckedChange:d(y),children:m},f)})})]})});import{forwardRef as wc,useState as en}from"react";import Qo from"styled-components";import{Close as on,Root as vc,Trigger as Rc}from"@radix-ui/react-popover";import{jsx as V,jsxs as uo}from"react/jsx-runtime";var Kb=wc(({container:e,asChild:o,children:t,min:r,max:n,unit:a,values:i=[],onValuesChange:s,triggerProps:l={}},p)=>{let c=a??"";if(r!==void 0&&n!==void 0&&r>n)throw Error("min prop must be less max prop");if(i[0]!==void 0&&i[1]!==void 0&&i[0]>i[1])throw Error("values prop is not ordered correctly");let[d,y]=en(),[m,f]=en(),h=()=>{let T=Number.isNaN(d)?void 0:d??i[0],C=Number.isNaN(m)?void 0:m??i[1],_=Te(T,r,n)?T:i[0],U=Te(C,r,n)?C:i[1],A=_!==void 0&&U!==void 0?[Math.min(_,U),Math.max(_,U)]:[_,U];y(void 0),f(void 0),s==null||s(A)},I=()=>{y(void 0),f(void 0),s==null||s([])},k=()=>{let T=i[0]??r,C=i[1]??n;return T=Te(T,r,n)?T:r,C=Te(C,r,n)?C:n,T===r&&C===n&&T===C&&T!==void 0?`${T} ${a}`:T===r&&C!==void 0?`< ${C}${c?` ${c}`:""}`:T!==void 0&&C===n?`> ${T}${c?` ${c}`:""}`:T!==void 0&&C!==void 0?`${T} - ${C}${c?` ${c}`:""}`:"Duration"},u=d??i[0],b=m??i[1];u=Number.isNaN(u)?void 0:u,b=Number.isNaN(b)?void 0:b;let w=u===void 0||Te(u,r,n)&&(b===void 0||u<=b),R=b===void 0||Te(b,r,n)&&(u===void 0||u<=b);return uo(vc,{children:[V(Rc,{asChild:!0,children:o?t:V(We,{...l,children:V(kc,{children:k()})})}),uo(io,{container:e,minWidth:"320px",ref:p,sideOffset:5,children:[uo(Gt,{children:[V(ge,{label:`Min duration${c?` (${c})`:""}`,children:V(tn,{error:!w,onChange:T=>y(parseInt(T.target.value)),type:"number",value:u??""})}),V(ge,{label:`Max duration${c?` (${c})`:""}`,children:V(tn,{error:!R,onChange:T=>f(parseInt(T.target.value)),type:"number",value:b??""})})]}),uo(Mc,{children:[V(on,{asChild:!0,children:V(F,{buttonTheme:"secondary",onClick:I,variant:"outline",children:"Clear"})}),V(on,{asChild:!0,children:V(F,{onClick:h,children:"Confirm"})})]})]})]})});var Te=(e,o,t)=>e!==void 0&&o!==void 0&&t!==void 0?o<=e&&e<=t:!0,kc=Qo.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: max-content;
`,tn=Qo(wo)`
  /* Chrome, Safari, Edge, Opera */
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  [type="number"] {
    -moz-appearance: textfield;
    appearance: textfield;
  }
`,Mc=Qo.div`
  display: flex;
  justify-content: right;
  gap: 8px;
  align-self: stretch;
`;import{createContext as Dc,forwardRef as rn,useContext as Bc,useMemo as Fc,useState as zc}from"react";import{Root as Ec,Item as Oc}from"@radix-ui/react-radio-group";import nn,{css as an}from"styled-components";import{jsx as yo}from"react/jsx-runtime";var sn=Dc({size:"lg",variant:"gradient"}),rh=rn(({size:e="lg",variant:o="gradient",textVariant:t,value:r,onValueChange:n,...a},i)=>{let[s,l]=zc();return yo(sn.Provider,{value:Fc(()=>({size:e,variant:o,textVariant:t,value:r??s}),[r,e,t,s,o]),children:yo(Lc,{...a,"data-size":e,"data-variant":o,onValueChange:p=>{l(p),n==null||n(p)},ref:i,value:r??s})})}),nh=rn(({children:e,...o},t)=>{let{size:r="lg",variant:n="gradient",value:a,textVariant:i}=Bc(sn),s=o.value===a;return yo(Ac,{$typography:i,...o,asChild:!0,"data-size":r,"data-variant":n,ref:t,children:yo(F,{buttonTheme:s?"primary":"secondary",variant:s?"solid":"ghost",children:e})})});var Lc=nn(Ec)`
  ${({theme:e})=>an`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 4px;
    box-sizing: border-box;
    gap: 2px;
    background-color: ${e.colors.gray3};
    box-shadow: ${e.shadows.base}, inset 0 0 0 1px ${e.colors.gray7};
    border-radius: 8px;
    width: fit-content;

    &[data-size="sm"] {
      height: 36px;
    }

    &[data-size="lg"] {
      height: 48px;
    }
  `}
`,Ac=nn(Oc)`
  ${({theme:e,$typography:o})=>an`
      && {
        display: inline-flex;
        height: 100%;

        &[data-state="checked"][data-variant="gradient"] {
          background: linear-gradient(
            180deg,
            ${v(e.colors.blue9,1)} 0%,
            ${v(e.colors.blue9,.64)} 100%
          );
          box-shadow: ${e.shadows.base};
          backdrop-filter: blur(8px);

          &:hover {
            background: linear-gradient(
              180deg,
              ${v(e.colors.blue10,1)} 0%,
              ${v(e.colors.blue10,.64)} 100%
            );
          }
        }

        ${o?e.styleSet[o]:void 0};
      }
    `}
`;import W,{css as et}from"styled-components";import{Slot as Nc}from"@radix-ui/react-slot";import{Fragment as Jc,jsx as H,jsxs as Ee}from"react/jsx-runtime";var ch=({title:e,description:o,logoUrl:t,logoAlt:r,tags:n=[],onClick:a,route:i,className:s,category:l,asChild:p,newWindow:c,gradientColor:d})=>{let y=h=>{a&&a()},m=()=>p?Nc:i?"a":"div",f=Ee(Jc,{children:[Ee(Wc,{children:[Ee(Gc,{children:[H(_c,{alt:r,src:t}),H(Uc,{children:H(g,{color:"white",variant:"textXs",children:l})})]}),H(Xc,{gradientColor:d})]}),Ee(jc,{children:[Ee(Zc,{children:[H(g,{color:"white",variant:"headingLg",children:e}),H(g,{color:"gray11",variant:"textXs",children:o})]}),n.length>0&&H(Kc,{children:n.map((h,I)=>H(Yc,{children:H(g,{color:"white",variant:"textXs",children:h})},I))})]})]});return H(Vc,{children:H(Hc,{as:m(),className:s,href:i,onClick:y,target:c?"_blank":void 0,children:f})})};var Vc=W.div`
  width: 100%;
  max-width: 358px;
  border: 1px solid transparent;
  border-radius: 14px;
  padding: 2px;
  background: ${({theme:e})=>`
    linear-gradient(${e.colors.gray2}, ${e.colors.gray2}) padding-box,
    linear-gradient(180deg, ${e.colors.gray6}, ${e.colors.gray2}) border-box
  `};
  background-clip: padding-box, border-box;
  background-origin: padding-box, border-box;
`,Hc=W.div`
  ${({theme:e})=>et`
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: ${e.colors.gray2};
    border: 1px solid ${e.colors.gray8};
    border-radius: 12px;
    text-decoration: none;
    cursor: pointer;
    &:hover {
      border-color: ${e.colors.gray9};
    }
  `}
`,Wc=W.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
`,Gc=W.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 1;
  padding: 16px;
`,Xc=W.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 50%;
  opacity: 0.15;
  background: linear-gradient(
    90deg,
    ${({gradientColor:e,theme:o})=>e||o.colors.gray6},
    ${({theme:e})=>e.colors.gray2}
  );
  border-radius: 10px 10px 0 0;
  z-index: 0;
  pointer-events: none;
`,_c=W.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
`,Uc=W.span`
  ${({theme:e})=>et`
    padding: 3px 8px;
    background-color: ${e.colors.gray4};
    border: 1px solid ${e.colors.gray6};
    border-radius: 22px;
  `}
`,jc=W.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0px 16px 16px 16px;
`,Zc=W.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`,Kc=W.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`,Yc=W.span`
  ${({theme:e})=>et`
    padding: 3px 8px;
    background-color: ${e.colors.gray4};
    border-radius: 22px;
    border: 1px solid ${e.colors.gray6};
  `}
`;export{Ad as Avatar,jd as Badge,Ju as Banner,hi as BoxedIcon,$y as BreadcrumbItem,wy as Breadcrumbs,F as Button,gm as ButtonGroup,zf as Callout,ol as Chart,Rr as ChartLegend,Ey as ChartNumericTooltip,Mr as ChartTooltip,yf as Checkbox,pr as CodeBox,$u as CodeWindow,ar as Copier,Kl as DateInput,Pb as DateTimePicker,Om as Drawer,Gt as Form,ge as FormControl,x as Icon,z as IconButton,wo as Input,Bd as Link,He as Menu,Ge as MenuContent,So as MenuDropdownTrigger,We as MenuDropdownTriggerImpl,eg as MenuGroup,we as MenuItem,pe as MenuTrigger,Tt as Modal,Im as ModalBody,Pm as ModalFooter,Mm as ModalHeader,Ab as MultiSelectDropdown,Fu as Pagination,Hg as Pill,Au as Progress,sf as RadioGroup,pf as RadioItem,Jg as Searchbar,Ot as Select,tu as Sidebar,Gu as Step,Pg as Table,Sg as TableBody,wg as TableCell,Cg as TableHead,$g as TableRow,py as TabsManager,ch as TemplateCard,qg as Textarea,Kn as ThemeProvider,mo as TimeInput,Kb as TimeRangeDropdown,rh as ToggleSwitch,nh as ToggleSwitchItem,Xe as Tooltip,g as Typography,q as defaultTheme,uy as defaultToastContainerProps,yy as toastContainerStyleSheet,Ce as useTheme};
